// window.addEventListener('DOMContentLoaded',function () {
// commented out because this is happened by script loader
// });

// declare variables

console.log('%c T H E O R E M', 'font-weight: bold; font-size: 40px; color: #555');
const { xs, sm, md, lg, xl } = window.breakpoints;

const body = document.querySelector('body');

function toggleAnimation(element, force) {
	let forceRemove, forceAdd;
	if (force !== undefined) {
		forceRemove = !force;
		forceAdd = force;
	}
	// toggle remove 
	if (element.hasAttribute('data-remove-class')) {
		let removeClasses = element.dataset.removeClass
		let remClsArr = removeClasses.split(' ');
		remClsArr.map(cl => element.classList.toggle(cl, forceRemove));
	}

	// toggle Active
	if (element.hasAttribute('data-add-class')) {
		let activeClasses = element.dataset.addClass
		let actClsArr = activeClasses.split(' ');
		actClsArr.map(cl => element.classList.toggle(cl, forceAdd));
	}
	
}

// toggle content
function toggleContent(element) {
	// set content for removal 
	if (element.hasAttribute('data-remove-content')) {
		var removeContent = element.dataset.removeContent
	}

	// set content for addition 
	if (element.hasAttribute('data-add-content')) {
		var addContent = element.dataset.addContent
	}
	
	if(element.innerHTML == removeContent) {
		element.innerHTML = addContent
	} else if (element.innerHTML == addContent) {
		element.innerHTML = removeContent
	} else {
		console.log('Content Does not match either');
	}
	
}

// Siblings selector 

function getAllSiblings(element, parent) {
	const children = [...parent.children];
	return children.filter(child => child !== element);
}

// resize element

function elementHeight(el) {
	if (window.innerWidth < md) {
		el.style.height = window.innerHeight + 'px';
	} else {
		el.style.height = 'auto'
	}
}

// resize element end

// Match Height

function setHeight(el, val) {
	if (typeof val === "function") val = val();
	if (typeof val === "string") el.style.height = val;
	else el.style.height = val + "px";
}
	
var equalheight = function () {

	var currentTallest = 0,
		currentRowStart = 0,
		rowDivs = new Array(),
		$el,
		topPosition = 0;

	var matchHeightSelectors = Array.from(document.querySelectorAll('[data-match-height]')).map(x => x.dataset.matchHeight).filter((value, index, self) => self.indexOf(value) === index)

	matchHeightSelectors.forEach(x => {
		const selector = '[data-match-height="'+ x +'"]' 
	
		document.querySelectorAll(selector).forEach((el, i) => {

			el.style.height = "auto";
			topPosition = el.offsetTop;
			if (currentRowStart != topPosition) {
				for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
					setHeight(rowDivs[currentDiv], currentTallest)
				}
				rowDivs.length = 0;
				currentRowStart = topPosition;
				currentTallest = parseFloat(getComputedStyle(el, null).height.replace("px", ""))
				rowDivs.push(el);
			} else {
				rowDivs.push(el);
				currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace("px", ""))) ? (parseFloat(getComputedStyle(el, null).height.replace("px", ""))) : (currentTallest);
			}
			for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
				setHeight(rowDivs[currentDiv], currentTallest)
			}
		})
	})
}

window.addEventListener("load", function(){
	equalheight();
});

window.addEventListener("resize", function(){
	setTimeout(function(){
		equalheight();
	})
});

// Match Height End

const burgerNavToggle = document.querySelector('[data-menu-icon]');
const burgerNavClose = document.querySelector('[data-nav-close-button]');
const menu = document.querySelector('[data-nav]');
const controlsWrapper = document.querySelector('[data-nav-controls-wrapper]');
const desktopLinkListWrapper = document.querySelector('[data-desktop-link-list-wrapper]');
const menuLinks = document.querySelectorAll('[data-nav-link]');

burgerNavToggle.addEventListener('click', toggleMenu);
burgerNavClose.addEventListener('click', (e)=>toggleMenu(e, false));

menuLinks.forEach(link => {
	link.addEventListener('click', (e) => {
		const isActive = menu.classList.toggle('active', false);
		controlsWrapper.classList.toggle('active', isActive);
		desktopLinkListWrapper.classList.toggle('fade', isActive);
	});
});

function toggleMenu(e, force) {
	e.preventDefault();
	toggleAnimation(body, force)
	const isActive = menu.classList.toggle('active', force);
	controlsWrapper.classList.toggle('active', isActive);
	desktopLinkListWrapper.classList.toggle('fade', isActive);
}

function dropdownFn(dropdown) {
	if (dropdown.dataset.closeSiblings && window.innerWidth >= xl) {
		const siblings = getAllSiblings(dropdown.parentElement, dropdown.parentElement.parentElement);
		Array.from(siblings).forEach(child => {
			if(child.children[1]) {
				let activeClass = child.children[1].dataset.addClass.split(' ');
				if (child.children[1].classList.contains(activeClass[0])) {	
					toggleAnimation(child.children[0]);
					toggleAnimation(child);
					if (child.children[0]) {
						toggleAnimation(child.children[0].children[0])
					}
					if (child.children[1]) {
						toggleAnimation(child.children[0].children[0])
					}
					toggleAnimation(child.children[1])
				}
			}
		});
	}
	
	toggleAnimation(dropdown)
	toggleAnimation(dropdown.parentElement)
	if (dropdown.children[0]) {
		toggleAnimation(dropdown.children[0])
	}
	if (dropdown.children[1]) {
		toggleAnimation(dropdown.children[1])
	}
	toggleAnimation(dropdown.nextElementSibling)
}

function headerDropdownInit() {
	var data_header_dropdown = document.querySelectorAll('[data-header-dropdown]');
	Array.from(data_header_dropdown).forEach((dropdown)=> {
		if (dropdown.classList.contains('init')) return;
		dropdown.classList.add('init')

		if(window.innerWidth >= xl) {
			dropdown.onmouseenter = () => eventHandler(event)
			dropdown.parentElement.onmouseleave = () => eventHandler(event)

			function eventHandler (event) {
				dropdownFn(dropdown)
			}
			dropdown.addEventListener('click', (e) => {
				e.preventDefault();
			});
		} else {

			dropdown.addEventListener('click', (e) => {
				e.preventDefault();
				dropdownFn(dropdown)
				
			})

		}

		// Checks if dropdown has data attr of data-close-siblings if it does and the window size is smaller than xl (1280) then it runs this with it always opens the dropdown
	})
};

headerDropdownInit();

function dropdownInit() {
	var data_dropdown = document.querySelectorAll('[data-dropdown]');
	Array.from(data_dropdown).forEach((dropdown)=> {
		if (dropdown.classList.contains('init')) return;
		dropdown.classList.add('init')
		dropdown.addEventListener('click', (e) => {
			e.preventDefault();
			// Checks if dropdown has data attr of data-close-siblings if it does and the window size is smaller than xl (1280) then it runs this with it always opens the dropdown

			dropdownFn(dropdown)
		})
	})
};

dropdownInit();


// initalise global vue app so multiple sections can be add to the site to use product cards 

window.apps = {}

let autoStageCounter = 1

const appInitialise = () => {

	document.removeEventListener("vue-initialise", appInitialise) 

	// setInterval(() => {

		// create a new app for any unmounted data-vue-app elements

		document.querySelectorAll('[data-vue-app]:not([data-v-app])').forEach(element => {

			if(!element.id) {
				element.id = 'vue-autostage-' + autoStageCounter++
			}
			
			window.apps[element.id] = buildApp(element.id)
			console.log('%cCreated app: ' + element.id)
		})

		splideInit();
		dropdownInit();
	// }, 500)

}

document.addEventListener('vue-initialise', appInitialise )
document.dispatchEvent(new Event('vue-initialise'))

const handleIntersection = (entries, observer) => {
	if (!entries[0].isIntersecting) return;

	observer.unobserve(productRecommendationsSection);

	const url = productRecommendationsSection.dataset.url;

	fetch(url)
	.then(response => response.text())
	.then(text => {
		
		const html = document.createElement('div');
		html.innerHTML = text;
		const recommendations = html.querySelector('.product-recommendations');
		if (recommendations && recommendations.innerHTML.trim().length) {
			productRecommendationsSection.innerHTML = recommendations.innerHTML;

			setTimeout(function(){
				document.addEventListener('vue-initialise', appInitialise )
				document.dispatchEvent(new Event('vue-initialise'))
			}, 100)
		}

	})
	.catch(e => {
		console.error(e);
	});
};

const productRecommendationsSection = document.querySelector('.product-recommendations');
const rpObserver = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px', threshold: .5});

if (productRecommendationsSection) {
	rpObserver.observe(productRecommendationsSection);
}

const shopifySection = document.querySelectorAll('.shopify-section');

if (shopifySection) {
	
	Array.from(shopifySection).forEach((section, index)=> {

		const sectionInner = section.querySelector('[data-url]')

		if(sectionInner) {
		
			const handleIntersectionSection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				
				observer.unobserve(section);

				const url = sectionInner.dataset.url;
				
				fetch(url)
				.then(response => response.text())
				.then(text => {
					
					const html = document.createElement('div');
					html.innerHTML = text.replace('<!--', '').replace('-->', '');
					const loadedSection = html.querySelector('.shopify-section');
					if (loadedSection && loadedSection.innerHTML.trim().length) {
						section.innerHTML = loadedSection.innerHTML;
						
						setTimeout(function(){
							document.addEventListener('vue-initialise', appInitialise )
							document.dispatchEvent(new Event('vue-initialise'))
						}, 100)
					}
					
				})
				.catch(e => {
					console.error(e);
				});
			};

			const sectionObserver = new IntersectionObserver(handleIntersectionSection, {rootMargin: '0px 0px 200px 0px', threshold: 0.5});

			sectionObserver.observe(section);
		}
	});
}


// vimeo logic

// all vimeos needs to be wrapped in this selector
const vimeoPlayer = document.querySelectorAll('[data-vimeo-wrapper]');



if(vimeoPlayer) {

	Array.from(vimeoPlayer).forEach((vimeo)=>vimeo.addEventListener('click', (e) => {
		let player = new Vimeo.Player(vimeo.querySelector('iframe'));
		let playPause = vimeo.querySelectorAll('[data-play-pause]');

		Array.from(playPause).forEach((button)=> {
			toggleAnimation(button);
		});
		
		player.getPaused().then(function(paused) {
			if(paused){
				player.play();
				if (vimeo.dataset.vimeoWrapper != 'muted') {
					player.setVolume(1);
				}
			} else {
				player.pause();
			}
		}); 
	}));

}


// vimeo logic end


//  Header Search form

const searchTrigger = document.querySelectorAll('[data-search-trigger]')
const searchForm = document.querySelector('[data-search-form]')

Array.from(searchTrigger).forEach((button)=>button.addEventListener('click', (e) => {
	e.preventDefault();
	toggleAnimation(searchForm);
}))



//  Header Search form end

// locale and currency form

const localeSelector = document.querySelectorAll('[data-locale-selector]')
const currencySelector = document.querySelectorAll('[data-currency-selector]')

const localizationForm = document.querySelectorAll('[data-localization-form]')

const localeIsoValue = document.querySelectorAll('[data-locale-iso-value]')
const currencyIsoValue = document.querySelectorAll('[data-currency-iso-value]')

Array.from(localeSelector).forEach((form)=>form.addEventListener('change', function() {
	localizationForm[0].submit()
}));

Array.from(currencySelector).forEach((form)=>form.addEventListener('change', function() {
	localizationForm[0].submit()
}));

Array.from(localeIsoValue).forEach((code)=>code.addEventListener('click', (e) => {
	e.preventDefault();
	localeSelector[0].value = code.dataset.localeIsoValue;
	triggerChange(localeSelector[0]);
}));

Array.from(currencyIsoValue).forEach((code)=>code.addEventListener('click', (e) => {
	e.preventDefault();
	currencySelector[0].value = code.dataset.currencyIsoValue;

	triggerChange(currencySelector[0]);
}));

function triggerChange(element) {
	let changeEvent = new Event('change');
	element.dispatchEvent(changeEvent);
}

// locale and currency form END




// media query logic


// window.addEventListener("resize", function() {
// 	if (window.matchMedia(`(min-width: ${md})`).matches) {
// 		console.log("Screen width is at least 768")
// 	}
// })


// media query logic end



// mailchimp form

let mcForm = document.querySelectorAll(".mc-form");
let mcSuccess = document.querySelectorAll(".mc-message.success");
let mcFail = document.querySelectorAll(".mc-message.error");

document.MC_callback = function(response) {

	if(response.result == "success") {
		// show success meassage
		Array.from(mcForm).forEach((form)=> {
			toggleAnimation(form);
			Array.from(mcSuccess).forEach((msg)=> {
				if (msg.classList.contains('hidden')) {
					toggleAnimation(msg);
					msg.innerHTML = response.msg
				}
			});
			Array.from(mcFail).forEach((msg)=> {
				if (msg.classList.contains('block')) {
					toggleAnimation(msg);
				}
			});
		});
		
	} else {
		// show error message
		Array.from(mcFail).forEach((msg)=> {
			if (msg.classList.contains('hidden')) {
				toggleAnimation(msg);
				msg.innerHTML = response.msg
			}
		});
	}
}

var serializeForm = function (form) {
	var obj = {};
	var formData = new FormData(form);
	for (var key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return obj;
};




const article_content = document.querySelector('[data-article-content]');

if (article_content) { 

	const article_image = article_content.querySelectorAll('img:not(.primary-img)');
	Array.from(article_image).forEach(img => {
		if(!img.parentNode.classList.contains('article-content')){
			let imgWrapper = img.parentElement;
			img.parentElement.classList.add('img-wrapper');
			console.log("wrapper",imgWrapper)

			let alt = img.getAttribute('alt');
			let append_class = 'single';

			if (alt.toLowerCase().includes('full')) {
				append_class = 'width-full';
				img.classList.add(`${append_class}`)
				//Add placeholder
				let height = window.getComputedStyle(img).height;
				img.parentElement.style.height = height;
			}

			if (alt.toLowerCase().includes('half')) {
				img.parentElement.classList.add('half-wrapper');
				append_class = 'width-half'
				img.classList.add(`${append_class}`)
			}

		}
		
	})
	

}

const productDetails = document.querySelectorAll('[data-product-details]');
// const productQuickButtons = document.querySelectorAll('[data-qb-button]');
const productQuickModal = document.querySelectorAll('[data-qb-modal]');

// creates a scope for the quick buy modal
Array.from(productDetails).forEach((scope) => {
	var x = scope.dataset.productId

	const trigger = scope.querySelectorAll('[data-qb-button]')
	
	Array.from(trigger).forEach((item)=>item.addEventListener('click', (e) => {			
		e.preventDefault();
		toggleAnimation(document.querySelector('[data-qb-modal="'+x+'"]'));
		toggleAnimation(document.querySelector('[data-overlay="'+x+'"]'));
	}));

	const subscriptionToggle = scope.querySelectorAll('[data-sub-toggle]');
	
	Array.from(subscriptionToggle).forEach((item)=>item.addEventListener('click', (e) => {
		e.preventDefault();
		if (!item.classList.contains('active')) {
			Array.from(subscriptionToggle).forEach((button) => {
				toggleAnimation(button);
			});
			toggleAnimation(document.querySelector('[data-frequency-selector="'+x+'"]'))
		}
	}));
	
});

// appends the modal to the body after setting up the scope.
// This is required because the cards can sit within a transformed element and then can't be fixed to the screen
Array.from(productQuickModal).forEach((modal) => {
	body.appendChild(modal);
});


// Share Api

const shareButton = document.querySelector('.share-button');
const shareDialog = document.querySelector('.share-dialog');
const closeButton = document.querySelector('.close-button');

if(shareButton) {

	shareButton.addEventListener('click', event => {
	if (navigator.share) { 
	navigator.share({
		title: shareButton.dataset.title,
		url: shareButton.dataset.url
		}).then(() => {
		console.log('Thanks for sharing!');
		})
		.catch(console.error);
		} else {
			toggleAnimation(shareDialog);
		}
	});

	closeButton.addEventListener('click', event => {
		toggleAnimation(shareDialog);
	});

}

// Copy URL

const copyContent = document.querySelectorAll('[data-copy]');

Array.from(copyContent).forEach((copy)=>copy.addEventListener('click', (e) => {
	e.preventDefault();
	// Get the text field
	var copyText = copy.querySelector("input");

	// Select the text field
	copyText.select();
	copyText.setSelectionRange(0, 99999); // For mobile devices
	
		// Copy the text inside the text field
	navigator.clipboard.writeText(copyText.value)
	.then(() => {
		console.log("successfully copied");
	})
	.catch(() => {
		console.log("something went wrong");
	});
	
}));

const showPassword = document.querySelectorAll('[data-show-password]');

Array.from(showPassword).forEach((password)=>password.addEventListener("change", (e) => {
	
	var scope = password.parentElement.parentElement

	var x = scope.querySelector('.password');
	
	if (x.type === 'password') {
		x.type = 'text';
	} else {
		x.type = 'password';
	}

	toggleContent(password.nextElementSibling);
}));


document.addEventListener("click", function(event){ 

	if (!event.target.matches('[data-product-view]')) return;

	event && event.preventDefault();
	
	if(event.target.dataset.productView == 'false') {

		const ProductCards = document.querySelectorAll('[data-product-card]');

		Array.from(ProductCards).forEach((card)=> {
			toggleAnimation(card);
		})

		const ProductListToggle = document.querySelectorAll('[data-product-view]');
		Array.from(ProductListToggle).forEach((item)=> {
			item.dataset.productView = 'false';
			toggleAnimation(item);
		});
		event.target.dataset.productView = 'true';
	}

});

// Sends event to cart component to trigger open and close 
const toggleCart = document.querySelectorAll('[data-toggle-cart]');

Array.from(toggleCart).forEach((item)=>item.addEventListener('click', (e) => {
	document.dispatchEvent(new Event('cartTrigger'));
}));




// const searchParamsPrev = window.location.search.slice(1);
// const filterForm = document.querySelector('[data-filter-form]'); // the whole wrapper
// const formInputs = filterForm.querySelectorAll('input') // all the inputs
// const collectionSection = document.querySelector('[data-collection]'); // the sections to be async loaded
// const sectionId = filterForm.dataset.filterForm // section Id

// Array.from(formInputs).forEach((input)=>input.addEventListener("change", (e) => {
// 	console.log('clicked', sectionId);
	
// 	let formData = new FormData(filterForm);
// 	let searchParams = new URLSearchParams(formData).toString();
// 	history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);

// 	// fetch new section
// 	fetch(`${window.location.pathname}?section_id=${sectionId}&${searchParams}`)
// 	.then(response => response.text())
// 	.then((responseText) => {
// 		unmountCollectionListingApp()
// 		document.querySelector('#collection').innerHTML = new DOMParser().parseFromString(responseText, 'text/html').querySelector('#collection').innerHTML;
// 		mountCollectionListingApp()
// 	})
// }));


const priceHandles = document.querySelectorAll('[data-price-handle]');

Array.from(priceHandles).forEach((handle)=> {
	handle.addEventListener('click', (e) => {
		e.preventDefault();
		Array.from(priceHandles).forEach((handle)=> {
			handle.classList.remove('active');
		});
		toggleAnimation(handle);	
		document.querySelector(`#${handle.dataset.priceHandle}`).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
	});
});

const toggleParentButton = document.querySelectorAll('[data-toggle-parent]')

Array.from(toggleParentButton).forEach((button)=> button.addEventListener('click', (e) => {
	
	var activeClass = button.parentElement.dataset.addClass.split(' ');
	var removeClass = button.parentElement.dataset.removeClass.split(' ');

	const siblings = getAllSiblings(button.parentElement, button.parentElement.parentElement);

	if (button.parentElement.classList.contains(removeClass[0])) {
		console.log('disable')
		// if the clicked button doesn't have active state
		Array.from(siblings).forEach(child => {
			if (child.classList.contains(activeClass[0])) {
				toggleAnimation(child)	
				toggleAnimation(child.querySelector('[data-toggle-sibling]'))
				toggleAnimation(child.querySelector('[data-toggle-sibling]').lastElementChild)
			}
		})
		toggleAnimation(button.parentElement)
		toggleAnimation(button.parentElement.querySelector('[data-toggle-sibling]'))
		toggleAnimation(button.parentElement.querySelector('[data-toggle-sibling]').lastElementChild)
		setTimeout(function(){
			button.parentElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
		}, 300)
	} else {
		console.log('able')
		// if the clicked button does have active state
		Array.from(siblings).forEach(child => {
			if (button.parentElement.classList.contains(activeClass[0])) {
				if (window.innerWidth > md) {
					toggleAnimation(child)
					toggleAnimation(child.querySelector('[data-toggle-sibling]'))
				} else {
					if (child.classList.contains(activeClass[0])) {
						toggleAnimation(child)
					} else {
						toggleAnimation(button.parentElement)
					}
				} 
			}
		})
		if (window.innerWidth < md) {
			toggleAnimation(button.parentElement.querySelector('[data-toggle-sibling]'))
		}
		toggleAnimation(button.parentElement.querySelector('[data-toggle-sibling]').lastElementChild)
		setTimeout(function(){
			button.parentElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
		}, 300)
	}
	
}));


// Handle clicks on cdx_account-nav
document.addEventListener('click', function(event) {
	const accountNav = event.target.closest('.cdx_account-nav');
	if (!accountNav) return;
	// Check if the click is directly on a button or anchor
	if (event.target.matches('button, a')) return;
	if (accountNav) {
		accountNav.classList.toggle('active');
	}
	
});
	


	






